<template>
  <div class="md:flex md:flex-wrap md:flex-shrink md:justify-center">
    <SpeakersListItem
      v-for="speaker in speakersList"
      :key="speaker.pk"
      :speaker="speaker"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SpeakersListItem from '@/components/SpeakersListItem'

export default {
  components: { SpeakersListItem },

  computed: {
    ...mapState('speakers', ['speakersList']),
  },
}
</script>
